import {
  ParticleDesignVersions
} from 'mage-deps/@klarna/bubble-ui'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import React from 'react'
import { TopBarActionButton } from 'mage-deps/@klarna/mp-ui'

import withToggleProps from './withToggleProps'

const ResponsiveMenuButton = ({ id, onClick, Icon, label, children, toggled, designVersion, ...props }) => {
  return (
    <TopBarActionButton
      id={id}
      Icon={Icon}
      label={label}
      toggled={toggled}
      onClick={onClick}
    />
  )
}

ResponsiveMenuButton.defaultProps = {
  designVersion: ParticleDesignVersions.DARK
}

ResponsiveMenuButton.propTypes = {
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  Icon: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  toggled: PropTypes.bool,
  designVersion: PropTypes.string
}

export default R.compose(
  withToggleProps({ toggled: true })
)(ResponsiveMenuButton)
